<template>
  <div class="c-categories">
    <router-link
      :tag="isCategorySelected ? 'h2' : 'h1'"
      :to="path"
      class="c-categories--foreground o-typography__headline3 o-typography--action"
    >
      {{ headerLeft }}
    </router-link>

    <div class="c-categories--foreground o-separator o-separator--accent o-separator--large"></div>

    <ui-categories-dropdown
      :categories="categories"
      :dropdown-header="headerRight"
      :is-category-selected="isCategorySelected"
    ></ui-categories-dropdown>
  </div>
</template>
<script>
  import UiCategoriesDropdown from './dropdown.vue';

  export default {
    components: {
      UiCategoriesDropdown,
    },
    props: {
      categories: Array,
      path: Object,
      headerLeft: String,
      headerRight: String,
      isCategorySelected: Boolean,
    },
  };
</script>
